export const iconFontAwesomeMedicalHealthPumpMedical = (
	<i className="fa-solid fa-pump-medical"></i>
);
